import { InjectionToken } from '@angular/core';

export const SN_NAVBAR_DATA = new InjectionToken('SN_NAVBAR_DATA');
